import { useGet } from '../../../sharedModules/hooks/useQuery';
import { AssignableUser } from '../model';

export function useAssignableUsers() {
  return useGet<AssignableUser[]>({ url: '/collections/assignable_users' });
}
